import { IS_B2B_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { GalleryCategoryType } from 'reactApp/modules/gallery/gallery.types';

export const DEFAULT_CATEGORY = IS_B2B_BIZ_USER ? GalleryCategoryType.images : GalleryCategoryType.all;

export const FAKE_GALLERY_ITEM_ID = 'fake-gallery-item-id';
